var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dateTime"},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))]),(!_vm.onlyDay)?_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }